import React, { useEffect, useState } from "react";
import { Spin, Button, notification } from "antd";
import { ReactSVG } from "react-svg";
import { forEach, filter } from "lodash";
import { Link } from "react-router-dom";
import socketIOClient from "socket.io-client";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";

import "./RoutePlanDetail.scss";
import ItemContainer from "../../modules/routePlan/containers/Item";
import withPage from "./withPage";
import RoutePlanLeft from "../RoutePlan/RoutePlanLeft";
import RoutePlanDrivers from "../RoutePlan/RoutePlanDrivers";
import RoutePlanOrders from "../RoutePlan/RoutePlanOrders";
import RoutePlanChart from "../RoutePlan/RoutePlanChart";
import StopsMapbox from "../Mapbox/StopsMapbox";
import { getStopsOrder, splitFirstOccurrence } from "../../utils/helper";
import { getTranslation } from "../../utils/helper";
import { doOptimizeDuplicateRoutePlan } from "../../modules/routePlan/stores/thunk";

const socketURI = process.env.REACT_APP_SOCKET_URI || "";
const socket = socketIOClient(socketURI);

const RoutePlanPage = ({
  isFetching,
  history,
  type,
  user,
  id,
  routePlan,
  doDetailRoutePlan,
  doRemoveOrdersRoutePlan,
  doRemoveDriversRoutePlan,
  doOptimizeRoutePlan,
  doReorderRoute,
  doDispatchRoutePlan,
  doLockDriver,
  doEditDriver,
  handleFailedOptimize,
  handleFetching,
  doDuplicateRoutePlan,
  query,
  orders,
  metadataOrders,
  doGetAllOrders,
  doUploadOrders,
  doAddOrdersRoutePlan,
  routePlanOrders,
}) => {
  const setting = useSelector(state => state.setting.setting) || user.company;
  const [api, contextHolder] = notification.useNotification();
  const dispatch = useDispatch();

  const routes = routePlan?.drivers || [];

  if (routePlan) {
    Cookies.set(
      `currentRoutePlan-${user._id}`,
      JSON.stringify({
        _id: routePlan._id,
        name: routePlan.name,
        deliveryDate: routePlan.deliveryDate,
        status: routePlan.status,
        totalOrders: routePlan.orders.length,
        totalDrivers: routePlan.drivers.length,
      }),
      { expires: 365 }, // expires 1 year
    );
  }
  const routePlanId = routePlan?._id;

  const [state, setState] = useState({});
  const [stepsHovered, setStepsHovered] = useState({});
  const [stepClicked, setStepClicked] = useState({});
  const [stops, setStops] = useState([]);
  const [isDuplicating, setIsDuplicating] = useState(false);
  // const [completed, setCompleted] = useState(false);

  const canEdit = !user?.roles?.includes("user");

  useEffect(() => {
    const handler = data => {
      if (data.event === "routePlan.optimizing.completed" && data.payload.routePlanId === id) {
        console.log("routePlan.optimizing.completed");
        // handleOptimizeCompleted();
        doDetailRoutePlan(id);
      }
      if (data.event === "routePlan.optimizing.error" && data.payload.routePlanId === id) {
        console.log("routePlan.optimizing.error");
        const drivers = routePlan?.drivers?.map(r => r.driver) || [];
        handleFailedOptimize();
        let message = data.payload.message;
        if (message.includes("Visit")) {
          const split1 = splitFirstOccurrence(message, ":");
          const split2 = splitFirstOccurrence(split1[0], " ");
          if (split1.length === 2 && split2.length === 2) {
            let orderId;
            if (split2[1].includes("_")) {
              const split3 = split2[1].split("_");
              orderId = split3[0];
            } else {
              orderId = split2[1];
            }
            const order = orders.find(o => o._id == orderId);
            if (order) message = order.orderCode + ": " + split1[1];
          }
        } else if (message.includes("_pickup") || message.includes("_dropoff")) {
          const message_arr = message?.split(" ") || [];
          message = message_arr
            .map(m => {
              if (m.includes("_pickup")) {
                const order_type = m.split("_");
                const orderId = order_type[0];
                const order = orders.find(o => o._id == orderId);
                if (order) {
                  return `Pickup ${order.orderCode}`;
                } else {
                  return m;
                }
              } else if (m.includes("_dropoff")) {
                const order_type = m.split("_");
                const orderId = order_type[0];
                const order = orders.find(o => o._id == orderId);
                if (order) {
                  return `Delivery ${order.orderCode}`;
                } else {
                  return m;
                }
              } else {
                return m;
              }
            })
            .join(" ");
        } else {
          const split1 = splitFirstOccurrence(message, ":");
          const driver = drivers.find(d => d._id === split1[0]);
          if (driver) {
            message = driver.name + ": " + split1[1];
          } else {
            const order = routePlanOrders.find(o => o._id === split1[0]);
            if (order) message = order.orderCode + ": " + split1[1];
          }
        }
        api.error({
          message,
          placement: "bottomRight",
        });
      }
    };
    socket.connect();
    socket.on(user.company?._id, handler);
    return () => socket.off(user.company?._id, handler);
  }, [routePlanId]);

  useEffect(() => {
    let stopsT = [];
    if (routePlan?.orders?.length > 0) {
      forEach(routePlan.orders, order => {
        stopsT = stopsT.concat(getStopsOrder(order));
      });
    }
    setStops(stopsT);
  }, [orders, routePlan?.orders]);

  useEffect(() => {
    if (routePlan?.status === "DRAFT" && routePlan?._id === id && type !== "orders" && type !== "drivers") {
      Cookies.remove("PreAction");
      history.push(`/route-plans/${routePlan._id}/${!routePlan?.orders?.length ? "add-orders" : "orders"}`);
    }
    // else if (completed && (type === "orders" || type === "drivers")) {
    //   history.push(`/route-plans/${routePlan._id}`);
    // }
  }, [routePlan, id]);

  const optimizeDuplicateRoute = async () => {
    setIsDuplicating(true);
    await dispatch(
      doOptimizeDuplicateRoutePlan({
        id,
        cloneRoute: routePlan.cloneRoute,
      }),
    );
    handleFetching();
  };

  useEffect(() => {
    if (
      routePlan?.cloneRoute &&
      routePlan.status === "DRAFT" &&
      !routePlan.optimizeDuplicateRoute &&
      type === "orders" &&
      !isDuplicating
    ) {
      optimizeDuplicateRoute();
    }
  }, [routePlan]);

  useEffect(() => {
    if (query.stopId) {
      const stop = stops.find(s => s.id === query.stopId);
      setTimeout(() => {
        onClickStop(stop);
      }, 1000);
    }
  }, [stops]);

  // const handleOptimizeCompleted = () => {
  //   // message.success("You action has been completed successfully.");
  //   setCompleted(true);
  //   doDetailRoutePlan(id);
  // };

  const onClosePopup = () => {
    setStepsHovered({});
    setState({ ...state, stopClicked: { id: "closed" }, routeClicked: {} });
    setStepClicked({});
  };

  const onClickStop = (stop, isClicked = true) => {
    if (stop?.orderId && stop?.type) {
      const key = `StepPopover-${stop.orderId}-${stop.type.toLowerCase()}`;
      setStepsHovered({ [key]: true });
      if (isClicked)
        setStepClicked({
          orderId: stop?.orderId,
          type: stop?.type,
          driverId: stop?.driverId,
        });
    } else {
      setStepsHovered({});
      if (isClicked) setStepClicked({});
    }
    setState({ ...state, stopClicked: stop, routeClicked: {} });
  };

  const onClickRoute = route => {
    if (route?.driver?._id) {
      setStepsHovered({ [route.driver._id]: true });
    } else {
      setStepsHovered({});
    }
    setState({ ...state, stopClicked: {}, routeClicked: route });
  };

  // const handleOptimize = () => {
  //   doOptimizeRoutePlan({ id, forceAll: false });
  // };

  if (routePlan?._id !== id) return <Spin style={{ paddingTop: 100, width: "100%" }} />;

  if (routePlan?.orders?.length === 0 && Cookies.get("PreAction") !== "AddOrders") {
    history.push(`/route-plans/${routePlan?._id}/add-orders`);
    return <Spin style={{ paddingTop: 100, width: "100%" }} />;
  }

  const showAddDrivers = type === "orders" && routes?.length === 0 && orders?.length !== 0;
  const showAddOrders = type === "drivers" && orders?.length === 0 && routes?.length !== 0;
  // const showOptimize =
  //   !showAddDrivers &&
  //   !showAddOrders &&
  //   routePlan?.status === "DRAFT" &&
  //   routePlan?._id === id;
  const showContinue =
    !showAddDrivers &&
    !showAddOrders &&
    (routePlan?.status === "OPTIMIZED" || routePlan?.status === "DISPATCHED") &&
    routePlan?._id === id;
  // const disable =
  //   (type === "orders" && orders?.length === 0) ||
  //   (type === "drivers" && routes?.length === 0);

  return (
    <Spin spinning={isFetching}>
      {contextHolder}
      <div className="Content ContentFull RoutePlanDetailPage">
        <RoutePlanLeft routePlan={routePlan} canEdit={canEdit} />
        {type === "drivers" || type === "orders" ? (
          <div className="ContentMain">
            <div className="MainLeft">
              {type === "drivers" && (
                <RoutePlanDrivers
                  id={id}
                  routePlan={routePlan}
                  routes={routes.map(r => ({ _id: r.driver._id, ...r }))}
                  doRemoveDriversRoutePlan={doRemoveDriversRoutePlan}
                  doDetailRoutePlan={doDetailRoutePlan}
                  onClickRoute={onClickRoute}
                  doEditDriver={doEditDriver}
                  setting={setting}
                />
              )}
              {type === "orders" && (
                <RoutePlanOrders
                  id={id}
                  routePlan={routePlan}
                  orders={routePlan.orders}
                  routes={routes}
                  doRemoveOrdersRoutePlan={doRemoveOrdersRoutePlan}
                  doDetailRoutePlan={doDetailRoutePlan}
                  onClickStop={onClickStop}
                  canEdit={canEdit}
                  setting={setting}
                />
              )}
            </div>
            <div className="MainRight">
              <StopsMapbox
                routes={canEdit ? routes : []}
                stops={filter(stops, s => s.lat && s.lng)}
                stopClicked={state.stopClicked}
                onClickStop={onClickStop}
                routeClicked={state.routeClicked}
                onClickRoute={onClickRoute}
                onClosePopup={onClosePopup}
                orders={routePlan?.orders || []}
              />
              {canEdit && (
                <div className="RoutePlanActions">
                  {showAddDrivers && (
                    <Link to={`/route-plans/${id}/add-drivers`}>
                      <Button size="large" className="NewButton" type="primary">
                        {getTranslation(setting, "Route Plans", "Add Drivers")}
                        <ReactSVG className="icon" src="/icons/add.svg" />
                      </Button>
                    </Link>
                  )}
                  {showAddOrders && (
                    <Link to={`/route-plans/${id}/add-orders`}>
                      <Button size="large" className="NewButton" type="primary">
                        {getTranslation(setting, "Route Plans", "Add Orders")}
                        <ReactSVG className="icon" src="/icons/add.svg" />
                      </Button>
                    </Link>
                  )}
                  {/* {showOptimize && (
                    <Button
                      disabled={disable}
                      size="large"
                      type="primary"
                      onClick={handleOptimize}
                    >
                      {getTranslation(setting, "Route Plans", "Optimize Route")}
                      <ReactSVG className="icon" src="/icons/continue.svg" />
                    </Button>
                  )} */}
                  {showContinue && (
                    <Link to={`/route-plans/${routePlan?._id}`}>
                      <Button size="large" type="primary">
                        {getTranslation(setting, "Route Plans", "Continue to Route")}
                        <ReactSVG className="icon" src="/icons/continue.svg" />
                      </Button>
                    </Link>
                  )}
                </div>
              )}
              {!canEdit && (
                <div className="RoutePlanActions">
                  {showContinue && (
                    <Link to={`/route-plans/${routePlan?._id}`}>
                      <Button size="large" type="primary">
                        {getTranslation(setting, "Route Plans", "Continue to Route")}
                        <ReactSVG className="icon" src="/icons/continue.svg" />
                      </Button>
                    </Link>
                  )}
                </div>
              )}
            </div>
          </div>
        ) : (
          <RoutePlanChart
            routePlan={routePlan}
            routes={routes}
            stops={stops}
            stopClicked={state.stopClicked}
            onClickStop={onClickStop}
            routeClicked={state.routeClicked}
            onClickRoute={onClickRoute}
            stepClicked={stepClicked}
            stepsHovered={stepsHovered}
            setStepsHovered={setStepsHovered}
            onClosePopup={onClosePopup}
            doOptimizeRoutePlan={doOptimizeRoutePlan}
            doReorderRoute={doReorderRoute}
            doDispatchRoutePlan={doDispatchRoutePlan}
            doLockDriver={doLockDriver}
            doDetailRoutePlan={doDetailRoutePlan}
            doEditDriver={doEditDriver}
            setting={setting}
            isFetching={isFetching}
            doDuplicateRoutePlan={doDuplicateRoutePlan}
          />
        )}
      </div>
    </Spin>
  );
};

export default withPage(ItemContainer(RoutePlanPage));
